export default "__VITE_ASSET__CjLKLNvj__"